import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { MenuItem } from "@/app/ui/navigation/types";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";

export const distributionAppMenu = {
  distributionApp: "distribution_app",
};

export const buildDistributionAppItems: () => MenuItem[] = () => [
  MenuItem.fromOpts({
    name: distributionAppMenu.distributionApp,
    icon: "Smartphone",
    url: "/distributionapp/",

    // Router will redirect to the correct page, but we need to provide an empty component for
    // the navigation logic to show the button, as we hide anything which has no
    // visible children or a viewable component
    view: async () => ({}),

    requiredUserPermissions: [EnumUserPermission.distributionApp],

    visible: () =>
      hasPermissionsUsingUserStore([
        EnumUserPermission.menuDistributionAppView,
      ]),
  }),
];
